import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import { faCog } from "@fortawesome/free-solid-svg-icons/faCog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { classeParaLabelsFormularioComFundoEscuroSimplificada } from "app/estilos/classeParaLabelsFormularioComFundoEscuro";
import { Documento, RespostaDocumentosAbertos } from "app/types/cliente/RespostaDocumentosAbertos";
import clsx from "clsx";
import React from "react";
import globalMU from "../../../globalMU";
import Legenda from "../itens-orcamento/legenda/Legenda";

const estiloTabela = require('../../estilos/tabelas.module.scss').default
const estilosFormulario = require('../../estilos/formulario.module.scss').default

type ColunaDocumentoAberto = {
  texto: string;
  coluna?: string;
  estilo: string;
  icon: boolean;
};

const itensLegendaDocumentosAbertos = [
  {
    nome: "Aberto",
    cor: "#BEBEBE"
  },
  {
    nome: "Doc. em Protesto ou em Cartório",
    cor: "#f00"
  },
  {
    nome: "Títulos Vencidos",
    cor: "#fc0"
  },
];

export type DadosDocumentos = {
  Atraso: number;
  CartorioProtesto: string;
  CodigoCliente: number;
  Creditos: number;
  DataEmissao: string;
  Desconto: number;
  Descricao: string;
  Encargos: number;
  Historico: string;
  LocalPortador: string;
  Numero: string;
  NumeroOrcamento: number;
  SituacaoCobranca: string;
  TipoDocumento: number;
  Valor: number;
  ValorTotal: number;
  Vencimento: string;
  Vendedor: string;
  UserMessage: string;
};

export type Documentos = {
  Documentos: Documento[];
  TotalCreditos: number;
  TotalDescontos: number;
  TotalDocumentoAVencer: number;
  TotalDocumentoVencido: number;
  TotalEncargos: number;
  TotalFinal: number;
  TotalGeral: number;
  TotalSubtotal: number;
  TotalValorDocumento: number;
  UserMessage: string;
};

export type DocumentosAbertosProps = {
  dadosDocumentosAbertos: Partial<RespostaDocumentosAbertos>;
  cpfcnpj: string;
  nome: string;
  onInfo: (dadosDocumentos: Documento) => void;
  colunaOrdenacao: string
  ordemOrdenacaoDecrescente: boolean
  usaFonteDeReceita?: boolean // 487678/449093 
  onAlterarOrdenacaoDados: (coluna: string, decrescente: boolean) => void;
};



export const DocumentosAbertos = React.memo((props: DocumentosAbertosProps) => {
  const {
    dadosDocumentosAbertos,
    cpfcnpj,
    nome,
    onInfo,
    colunaOrdenacao,
    ordemOrdenacaoDecrescente,
    usaFonteDeReceita,
    onAlterarOrdenacaoDados
  } = props;

  const dadosClienteDocAberto = React.useMemo(() => (
    <section id="documentosAbertosCliente_dadosCliente"
      className={clsx(estilosFormulario.formularioSimplificado, classeParaLabelsFormularioComFundoEscuroSimplificada)}>
      <label>CNPJ</label>
      <span>{cpfcnpj}</span>
      <label>Nome</label>
      <span>{nome}</span>

      {<section style={{ marginBottom: "20px" }} />}
    </section>
  ), [cpfcnpj, nome])


  const legendaDocumentosAbertos = React.useMemo(() => (
    <section id="documentosAbertosCliente_legenda" >
      <Legenda itens={itensLegendaDocumentosAbertos} />
    </section>
  ), [])

  const colunas = React.useMemo<ColunaDocumentoAberto[]>(() => [
    { texto: "Nº Doc.", coluna: "Numero", estilo: estiloTabela.cabecalhoTexto, icon: true },
    { texto: "Vencimento", coluna: "Vencimento", estilo: estiloTabela.cabecalhoNumerico, icon: true },
    { texto: "Valor Doc.", coluna: "Valor", estilo: estiloTabela.cabecalhoNumerico, icon: true },
    { texto: "Dias de Atraso", coluna: "DiasAtraso", estilo: estiloTabela.cabecalhoNumerico, icon: true },
    { texto: "Créditos", coluna: "Creditos", estilo: estiloTabela.cabecalhoNumerico, icon: true },
    { texto: "Encargos", coluna: "Encargos", estilo: estiloTabela.cabecalhoNumerico, icon: true },
    { texto: "Descontos", coluna: "Descontos", estilo: estiloTabela.cabecalhoNumerico, icon: true },
    { texto: "Total", coluna: "Total", estilo: estiloTabela.cabecalhoNumerico, icon: true },
    ...(usaFonteDeReceita ? [{ texto: "Fonte de Receita", coluna: "FonteDeReceita", estilo: estiloTabela.cabecalhoTexto, icon: true }] : []), // 487678/449093 
    { texto: "", estilo: estiloTabela.cabecalhoOperacao, icon: false }
  ], [usaFonteDeReceita]);

  const alterarOrdenacao = React.useCallback((coluna: string) => {
    onAlterarOrdenacaoDados(coluna, colunaOrdenacao == coluna ? ordemOrdenacaoDecrescente ? false : true : false)
  }, [colunaOrdenacao, ordemOrdenacaoDecrescente, onAlterarOrdenacaoDados])

  const cabecalhoTabelaDocAbertos = React.useMemo(() => (
    <thead
      id = "documentosAbertosCliente_cabecalhoTabela"
    >
      <tr
        id="documentosAbertosCliente_cabecalhoTabela_linha"
      >
        {colunas.map((x, index) =>
          <th className={x.estilo}
            id={`documentosAbertosCliente_cabecalhoTabela_coluna_${x.coluna}_${index}`}
            key={`documentosAbertosCliente_cabecalhoTabela_coluna_${x.coluna}_${index}`}
          >
            {x.icon ?
              <div className="_flex _justify-between">
                {x.texto}
                <div>
                  <FontAwesomeIcon color={colunaOrdenacao == x.coluna && "#008000"} icon={colunaOrdenacao == x.coluna ? ordemOrdenacaoDecrescente ? faChevronUp : faChevronDown : faChevronDown}
                    cursor={"pointer"} onClick={() => alterarOrdenacao(x.coluna)} />
                </div>
              </div> :
              x.texto ||
              <FontAwesomeIcon
                icon={faCog}
                color={"#80888a"}
                fontSize={"20px"}
              />
            }
          </th>
        )}
      </tr>
    </thead>
  ), [alterarOrdenacao, colunaOrdenacao, colunas, ordemOrdenacaoDecrescente])


  const corpoTabelaDocAbertos = React.useMemo(() => (
    <tbody
      id="documentosAbertosCliente_corpoTabela"
    >
      {
        dadosDocumentosAbertos?.Documentos?.map((value, index) => (
          <tr className={estiloTabela.dadoNumerico}
            id={`documentosAbertosCliente_corpoTabela_linha_${index}`}
            key={`documentosAbertosCliente_corpoTabela_linha_${index}`}
          >
            <td className={estiloTabela.dadoTexto}
              style={value.TipoDocumento == 1
                ? { boxShadow: "4px 0 #BEBEBE inset" }
                : value.TipoDocumento == 2
                  ? { boxShadow: "4px 0 #f00 inset" }
                  : value.TipoDocumento == 3
                    ? { boxShadow: "4px 0 #fc0 inset" }
                    : {}}>
              {value.Numero}
            </td>
            <td>{value.Vencimento}</td>
            <td>{globalMU.formatarValorNumerico(value.Valor, 2)}</td>
            <td>{value.Atraso}</td>
            <td>{globalMU.formatarValorNumerico(value.Creditos, 2)}</td>
            <td>{globalMU.formatarValorNumerico(value.Encargos, 2)}</td>
            <td>{globalMU.formatarValorNumerico(value.Desconto, 2)}</td>
            <td>{globalMU.formatarValorNumerico(value.ValorTotal, 2)}</td>
            {usaFonteDeReceita && // 487678/449093  
              <td className={estiloTabela.dadoTexto}
                id={`documentosAbertosCliente_corpoTabela_fonteDeReceita_linha_${index}`}
              >{value.FonteDeReceita}</td>}
            <td className={estiloTabela.dadoOperacao}><FontAwesomeIcon
              cursor={"pointer"}
              color={"#3c8ac9"}
              fontSize={"20px"}
              icon={faCircleInfo}
              onClick={() => onInfo(value)}
            />
            </td>
          </tr>
        ))}
    </tbody>
  ), [dadosDocumentosAbertos?.Documentos, onInfo, usaFonteDeReceita])

  const rodapeTabelaDocAbertos = React.useMemo(() => (
    <tfoot >
      <tr style={{ paddingTop: "unset" }}>
        <th style={{ paddingTop: "unset" }} colSpan={2} className={estiloTabela.cabecalhoNumerico}>Total</th>
        <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>
          {globalMU.formatarValorNumerico(dadosDocumentosAbertos?.TotalValorDocumento, 2)}
        </th>
        <th style={{ paddingTop: "unset" }}></th>
        <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>
          {globalMU.formatarValorNumerico(dadosDocumentosAbertos?.TotalCreditos, 2)}
        </th>
        <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>
          {globalMU.formatarValorNumerico(dadosDocumentosAbertos?.TotalEncargos, 2)}
        </th>
        <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>
          {globalMU.formatarValorNumerico(dadosDocumentosAbertos?.TotalDescontos, 2)}
        </th>
        <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>
          {globalMU.formatarValorNumerico(dadosDocumentosAbertos?.TotalFinal, 2)}
        </th>
        {usaFonteDeReceita && <th></th>}
        <th></th>
      </tr>

      <tr style={{ backgroundColor: "unset" }}>
        <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Total Vencido</th>
        <td className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(dadosDocumentosAbertos?.TotalDocumentoVencido, 2)}</td>
        <td colSpan={usaFonteDeReceita ? 8 : 7}></td>
      </tr>
      <tr style={{ backgroundColor: "unset" }}>
        <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Total A Vencer</th>
        <td className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(dadosDocumentosAbertos?.TotalDocumentoAVencer, 2)}</td>
      </tr>
      <tr style={{ backgroundColor: "unset" }}>
        <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Subtotal</th>
        <td className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(dadosDocumentosAbertos?.TotalSubtotal, 2)}</td>
      </tr>
      <tr style={{ backgroundColor: "unset" }}>
        <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Total Encargos</th>
        <td className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(dadosDocumentosAbertos?.TotalEncargos, 2)}</td>
      </tr>
      <tr style={{ backgroundColor: "unset" }}>
        <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Total</th>
        <td className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(dadosDocumentosAbertos?.TotalGeral, 2)}</td>
      </tr>
    </tfoot>
  ), [dadosDocumentosAbertos, usaFonteDeReceita])

  const tabelaDocumentoEmAberto = React.useMemo(() => (
    <section className={estiloTabela.containerRolavel}>
      <table id="grid-documentosEmAberto-cliente" className={`_table _w-full _border-collapse text-right ${estiloTabela.tabela}`}>
        {cabecalhoTabelaDocAbertos}
        {corpoTabelaDocAbertos}
        {rodapeTabelaDocAbertos}
      </table>
    </section>
  ), [cabecalhoTabelaDocAbertos, corpoTabelaDocAbertos, rodapeTabelaDocAbertos])


  return (
    <section>
      {dadosDocumentosAbertos != undefined &&
        <>
          {dadosClienteDocAberto}
          {tabelaDocumentoEmAberto}
          {legendaDocumentosAbertos}
          {<section style={{ marginBottom: "100px" }} />}
        </>
      }
    </section>
  );
});

DocumentosAbertos.displayName = "DocumentosAbertos";
